const METRICS = [
  { key: 'alarms', label: 'Alarmas', color: '#79baff' },
  { key: 'apv', label: 'Al. / visita', color: '#e07fb0', digits: 2 },
  { key: 'apt', label: 'Al. / tonelada', color: '#e39a4f', digits: 2 },
  { key: 'ppa', label: 'Pellets perdidos', color: '#a88cf0' },
  { key: 'visitas', label: 'Visitas', color: '#6fb6e6' },
  { key: 'kg', label: 'Alimento entregado', color: '#41a3cf', digits: 3, unit: ' ton' },
  { key: 'sfr', label: 'SFR promedio', color: '#4fd1a0', digits: 1, unit: ' %' },
];

const format = (value, metric) => value == null || !Number.isFinite(value) ? 'Sin datos'
  : value.toLocaleString('es-CL', { maximumFractionDigits: metric.digits || 0 }) + (metric.unit || '');

/** Uses the same daily backend values and SFR aggregation as the V1 charts. */
export function areaSummaryValues(panel) {
  const { rows, days } = panel.data;
  const { state } = panel;
  const metric = METRICS.find(item => item.key === state.areaSummaryMetric) || METRICS[0];
  const buckets = panel.periodBuckets();
  const period = buckets[state.areaSummaryPeriod];
  const indices = period || days.map((_, di) => di);
  const selected = new Set([state.sel, ...(state.cmp8 || [])]);
  const cellsOf = row => indices.map(di => row.cells[di]);
  const aggregate = (key, cells) => panel.v1MetricAggregate(key, cells);
  const totals = rows.filter((_, ci) => selected.has(ci)).flatMap(cellsOf);
  const values = rows.map(row => {
    const cells = cellsOf(row);
    return cells.some(cell => !cell.missing) ? aggregate(metric.key, cells) : null;
  });
  const max = Math.max(1, ...values.filter(Number.isFinite));
  const hasData = totals.some(cell => !cell.missing);

  return {
    metric,
    metrics: METRICS,
    setMetric: key => panel.setState({ areaSummaryMetric: key }),
    period: period ? String(state.areaSummaryPeriod) : '',
    periods: buckets.map((bucket, index) => ({ value: String(index), label: panel.periodLabel(bucket, true) })),
    setPeriod: value => panel.setState({
      areaSummaryPeriod: value === '' ? null : Number(value),
      ...(buckets[value] ? { day: buckets[value][0], hover: null } : {}),
    }),
    periodLabel: period ? panel.periodLabel(period, true) : 'Período completo',
    selectionLabel: selected.size === rows.length ? 'Todos los centros' : `${selected.size} ${selected.size === 1 ? 'centro seleccionado' : 'centros seleccionados'}`,
    kpis: ['alarms', 'ppa', 'kg', 'sfr'].map(key => {
      const definition = METRICS.find(item => item.key === key);
      return { ...definition, value: format(hasData ? aggregate(key, totals) : null, definition) };
    }),
    rows: rows.map((row, ci) => ({
      id: row.id,
      name: row.name,
      selected: selected.has(ci),
      value: format(values[ci], metric),
      width: `${(values[ci] || 0) / max * 100}%`,
      select: () => panel.setState({ sel: ci, cmp8: [] }),
    })),
  };
}
